import React, { useState } from "react";
import { Box, Typography, TextField, Button, FormControlLabel, Checkbox, Grid } from "@mui/material";
import emailjs from "emailjs-com";
import "../App.css";

const ContactUs = () => {

  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  const CONFIG = {
    SERVICE_ID: process.env.REACT_APP_EMAILJS_SERVICE_ID,
    TEMPLATE_ID: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
    PUBLIC_KEY: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
    CONTACT_EMAIL: process.env.REACT_APP_CONTACT_EMAIL
  };

  const emailMsg= "Email Sent Successfully";
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    country: "",
    organization: "",
    role: "",
    message: "",
    subscribe: false,
    privacyPolicy: false,
  });

  

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData({
      ...formData,
      [name]: checked,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Prepare EmailJS variables
    const emailParams = {
      recipient: CONFIG.CONTACT_EMAIL, // Replace with the recipient email
      reply_to: formData.email,
      fullName: formData.fullName,
      email: formData.email,
      phone: formData.phone || "Not Provided",
      country: formData.country,
      organization: formData.organization,
      role: formData.role,
      message: formData.message,
      subscribe: formData.subscribe ? "Yes" : "No",
      privacyPolicy: formData.privacyPolicy ? "Agreed" : "Not Agreed",
    };

    // Send email using EmailJS
    emailjs
      .send(
         CONFIG.SERVICE_ID, // Replace with your EmailJS Service ID
         CONFIG.TEMPLATE_ID, // Replace with your EmailJS Template ID
         emailParams,
         CONFIG.PUBLIC_KEY// Replace with your EmailJS Public Key
      )
      .then(
        (result) => {
          setIsFormSubmitted(true);
          console.log("Email Sent Successfully:", result.text);
        },
        (error) => {
          console.error("Email Sending Error:", error.text);
        }
      );
  };

  return (
    <Box sx={{ padding: 4, backgroundColor: "#f8f9fa" }}>
      {/* Main Form Container with 80% width */}
      <Box
        sx={{
          backgroundColor: "#ffffff",
          borderRadius: "15px",
          padding: "2rem",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
          width: "80%",
          margin: "0 auto", // Centers the content horizontally
        }}
      >
        {/* Page Title */}
        <Typography variant="h2" align="center" sx={{ fontWeight: 700, marginBottom: 4, color: "#2de2bf" }}>
          Contact Us
        </Typography>

        {/* Subtitle */}
        {/* <Typography variant="h5" align="center" sx={{ marginBottom: 4, color: "#555" }}>
          Let’s co-engineer the excellent future of your business together!
        </Typography> */}
        {isFormSubmitted ? (
          <Typography
            variant="h5"
            align="center"
            sx={{ marginTop: 4, color: "#4caf50", minHeight: "30vh", fontWeight: 600 }}
          >
            Thank you for reaching out to us! Your message has been sent successfully.
          </Typography>
        ) : ( 
        <>
          <Typography variant="h6" align="center" sx={{ marginBottom: 2, color: "#333" }}>
            Have a question? Fill the form below and we’ll be in touch
          </Typography>

          {/* Form */}
          <form onSubmit={handleSubmit} className="custom-form" style={{ width: '80%', margin: '0 auto' , maxWidth: 'none'}} >
            <Grid container spacing={3} justifyContent="center">
              {/* Full Name */}
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Full Name"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleInputChange}
                  required
                />
              </Grid>

              {/* Email */}
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </Grid>

              {/* Phone */}
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                />
              </Grid>

              {/* Country */}
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Country"
                  name="country"
                  value={formData.country}
                  onChange={handleInputChange}
                  required
                />
              </Grid>

              {/* Organization */}
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Organization"
                  name="organization"
                  value={formData.organization}
                  onChange={handleInputChange}
                  required
                />
              </Grid>

              {/* Role */}
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Role"
                  name="role"
                  value={formData.role}
                  onChange={handleInputChange}
                  required
                />
              </Grid>

              {/* Message */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Your Message (text only)"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  multiline
                  rows={4}
                  required
                />
              </Grid>

              {/* Submit Button */}
              <Grid item xs={12}>
                <Button type="submit" variant="contained" color="primary">
                  Submit
                </Button>
              </Grid>
            </Grid>
          </form>

          {/* Footer Contact Info */}
          <Box sx={{ marginTop: "4rem", textAlign: "center", backgroundColor: "#f8f9fa", padding: "2rem", borderRadius: "8px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>
            <Typography 
              variant="h5" 
              gutterBottom 
              sx={{
                fontWeight: 700,
                color: "#333",
                fontSize: "2rem",
                marginBottom: "1rem",
                letterSpacing: "0.5px"
              }}
            >
              Get in Touch
            </Typography>
            <Typography 
              variant="body1" 
              sx={{
                fontSize: "1.1rem",
                color: "#555",
                marginBottom: "1.5rem",
                lineHeight: "1.6",
              }}
            >
              We’d love to hear from you. Reach out to us for any inquiries, suggestions, or collaborations.
            </Typography>
            <Typography 
              variant="body1" 
              sx={{
                fontSize: "1rem",
                color: "#2de2bf",
                fontWeight: 600,
                "&:hover": {
                  textDecoration: "underline",
                  cursor: "pointer",
                }
              }}
            >
              Email: <a href="mailto:info@jaasc.io" style={{ color: "inherit", textDecoration: "none" }}>info@jaasc.io</a>
            </Typography>
          </Box>
          
        </>
        )}
        <Box sx={{ padding: "2rem", marginTop: "1rem", backgroundColor: "#f9f9f9" }}>
          <Grid container spacing={4} alignItems="flex-start">
            {/* Address Section */}
            <Grid item xs={12} md={5}>
              <Box
                sx={{
                  padding: "2rem",
                  backgroundColor: "#e9f5fc",
                  borderRadius: "12px",
                  border: "1px solid #d0e3f0",
                  boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.1)",
                  textAlign: "left",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: "1.3rem",
                    fontWeight: 700,
                    color: "#002d62",
                    marginBottom: "1rem",
                  }}
                >
                  Office Headquarters
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: "1rem",
                    color: "#555",
                    lineHeight: "1.8",
                  }}
                >
                  Co-working Space,
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: "1rem",
                    color: "#555",
                    lineHeight: "1.8",
                  }}
                >
                  459, Shri Krishna Temple Rd
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: "1rem",
                    color: "#555",
                    lineHeight: "1.8",
                  }}
                >
                  Indira Nagar 1st Stage, Stage 1
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: "1rem",
                    color: "#555",
                    lineHeight: "1.8",
                  }}
                >
                  Indiranagar, Bengaluru
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: "1rem",
                    color: "#555",
                    lineHeight: "1.8",
                  }}
                >
                  Karnataka 560038
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: "1rem",
                    color: "#555",
                    lineHeight: "1.8",
                  }}
                >
                  India
                </Typography>
              </Box>
            </Grid>

            {/* OpenStreetMap Section */}
            <Grid item xs={12} md={7}>
              <Box
                sx={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.1)",
                  height: "100%",
                }}
              >
                <iframe
                  title="Location Map"
                  src="https://www.openstreetmap.org/export/embed.html?bbox=77.6359%2C12.9738%2C77.6399%2C12.9778&layer=mapnik&marker=12.9758%2C77.6379"
                  width="100%"
                  height="300"
                  style={{
                    border: 0,
                  }}
                  allowFullScreen
                  loading="lazy"
                ></iframe>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default ContactUs;
